  import React, { useEffect, useState } from 'react'
  import './DepartmentAndsubDepartment.css'
  import { Button, Card, Col, Row } from 'antd';
  // import { Button, Card, Col, Row, Table } from 'antd';
  import { useLocation, useNavigate } from "react-router-dom";
  import { CheckCircleFilled, ClockCircleFilled, LeftOutlined, RightOutlined,DeleteOutlined } from '@ant-design/icons';
  import { BsMap, BsPencil } from "react-icons/bs";
  import { useForm, Controller, useFieldArray } from 'react-hook-form';
  import { Modal } from 'antd'; // Import Modal
  import { AddDepartment, AddSubDepartment, BASE_URL, DeleteDepartment, FetchDepartment, UpdateDepartment, UpdateSubDepartment } from '../../utils/constant';
  import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.min.css';
  import { useDispatch, useSelector } from 'react-redux';
  import SignUpSidebar from '../../common/SignUpSidebar';
  import { setDept } from '../../store/slices/departmentSlice';
  import ModalConfirm from '../../common/modalConfirm';
  import DepartmentForm from './DepartmentForm';
  import EditIcon from '../../assets/icons/add.svg';
  import Right from '../../assets/icons/right.svg';
  import Left from '../../assets/icons/left.svg';
  import { StopOutlined } from '@ant-design/icons';
  function DepartmentAndsubDepartment() {
    const location = useLocation();
    const [apendValue , setAppendValue] = useState(false)
    const dispatch = useDispatch();

    const capitalizeFirstLetter = (str) => {
      return str?.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const [data, setData] = useState([]);
    const [formattedData, setformattedData] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    // sub form
    const [openSubDeptForm, setOpenSubDeptForm] = useState(false);
    const [editSubDeptFormData, setEditSubDeptFormData] = useState(null);
    const [addSubdeptId, setAddSubdeptId] = useState(null);
    const [departmentId, setDepartmentId] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [callFetch, setCallFetch] = useState(false);
    const [modalDeleteDeptVisible, setModalDeleteDeptVisible] = useState(false);
    const [deleteDeptData, setDeleteDeptData] = useState(null);

    const deleteDept = (params) => {
      setModalDeleteDeptVisible(true);
      setDeleteDeptData(params)      
    };
    const handleOk = (params) => {
      console.log('deleteDepartment')

      deleteDepartment(params)     
      setModalDeleteDeptVisible(false);
    };
    const handleCancel = () => {
      setModalDeleteDeptVisible(false);
    };
    const [modalDeleteSubDeptVisible, setModalDeleteSubDeptVisible] = useState(false);
    const [deleteSubDeptData, setDeleteSubDeptData] = useState(null);

    const deleteSubDept = (params) => {
      setModalDeleteSubDeptVisible(true);
      setDeleteSubDeptData(params)      
    };
    const handleSubOk = (params) => {
      console.log('params',params)
      console.log('deleteSubDepartment')
      deleteSubDepartment(params)     
      setModalDeleteSubDeptVisible(false);
    };
    const handleSubCancel = () => {
      setModalDeleteSubDeptVisible(false);
    };
    const {
      companyName = "",
      firstName = "",
      lastName = "",
      email = "",
      phoneNumber = "",
      aadharNumber = "",
    } = useSelector((state) => state.signUp.signUpDetails);
    const { control: controlSubDept, handleSubmit: handleSubmitSubDept, reset: resetSubDeptForm, register: registerSubDept } = useForm({
      defaultValues: editSubDeptFormData || {
        subDepartments: [{ subDeptName: '', subDeptShortName: '', subDeptDescription: '' }],
      },
    });
    
    const { fields: subDeptFields, append: appendSubDept, remove: removeSubDept } = useFieldArray({
      control: controlSubDept,
      name: 'subDepartments',
    });
    
    const onEditSubDeptSubmit = async (formData) => {
      // Your logic for submitting edited sub-department data
      let isError = false;
      console.log(formData)
              // Validate sub-department fields
                if (!formData.subDeptName || formData.subDeptName.trim() === '') {
                  toast.error(`Please fill in Sub-Department Name.`);
                  isError = true;
                }
            
                if (!formData.subDeptShortName || formData.subDeptShortName.trim() === '') {
                  toast.error(`Please fill in Sub-Department Short Name.`);
                  isError = true;
                }
            
              
            
              // If any error occurred, return early
              if (isError) {
                return;
              }
      const { subDepartments, ...editsubDeptData } = formData;
      editsubDeptData.subDeptId = editSubDeptFormData.subDeptId;
      const filteredNewObject = Object.fromEntries(
        Object.entries(editsubDeptData).filter(([key, value]) => value !== '')
      );

      console.log('editsubDeptData',editsubDeptData)
      console.log('filteredSubDeptData',filteredNewObject)
      const token = localStorage.getItem('authToken');

      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${UpdateSubDepartment}/${departmentId}`, {
          method: "PUT",
          headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify(filteredNewObject),
        });
        
        if (response.ok) {
          const data = await response.json();
    
          console.log('CompanyDataa',data)
          setCallFetch(true)
        } else {
          const data = await response.json();
          console.log('CompanyDataerr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      fetchData();
      setOpenSubDeptForm(false);
      setEditSubDeptFormData(null);
    };
    
    const onSubDeptSubmit = async (formData) => {
      let isError = false;

      // Validate sub-department fields
      formData.subDepartments.forEach((subDept, index) => {
        if (!subDept.subDeptName || subDept.subDeptName.trim() === '') {
          toast.error(`Please fill in Sub-Department Name #${index + 1}.`);
          isError = true;
        }
    
        if (!subDept.subDeptShortName || subDept.subDeptShortName.trim() === '') {
          toast.error(`Please fill in Sub-Department Short Name #${index + 1}.`);
          isError = true;
        }
    
      });
    
      // If any error occurred, return early
      if (isError) {
        return;
      }
      // Extract subDepartments array from formData
      const { subDepartment, ...subDeptData } = formData;
      const filteredSubDepartments = subDeptData?.subDepartments?.map((item) => {
        const filteredItem = Object.fromEntries(
          Object.entries(item).filter(([key, value]) => value !== '')
        );
        return filteredItem;
      });
      const filteredSubDeptData = { subDepartments: filteredSubDepartments };

      // Log subDeptData and subDepartments separately
      console.log('Sub-Department Data:', subDeptData);
      console.log('Sub-Departments Array:', filteredSubDeptData);
      const finalSubdeptArray = {
        subDepartments : subDepartment
      }
      const token = localStorage.getItem('authToken');
  console.log('url',`${BASE_URL}/${AddSubDepartment}/${addSubdeptId}`)
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${AddSubDepartment}/${addSubdeptId}`, {
          method: "POST",
          headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify(filteredSubDeptData),
        });
        
        if (response.ok) {
          const data = await response.json();
          setCallFetch(true)
          console.log('CompanyDataa',data)
      
        } else {
          const data = await response.json();
          console.log('CompanyDataerr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      fetchData();
    console.log('finalSubdeptArray',finalSubdeptArray)
      setOpenSubDeptForm(false);
      resetSubDeptForm(); // Reset the form after submission
    };

    const editSubDepartment = (departmentId,subDepartment) => {
      setIsEdit(true)
      console.log('subDepartment',subDepartment)
      setDepartmentId(departmentId)
      setEditSubDeptFormData(subDepartment)
      setOpenSubDeptForm(true)
    }

    const deleteSubDepartment = ({item,data}) =>{
      console.log('id',data)
      const token = localStorage.getItem('authToken');
    
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${UpdateSubDepartment}/${item?.departmentId}`, {
            method: "PUT",
              headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({
              subDeptId:data?.subDeptId,
              subDeptName:data?.subDeptName,
              subDeptShortName:data?.subDeptShortName,
              subDeptDescription:data?.subDeptDescription,
            
              isActive:false
            }),
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('CompanyDataa',data)
            getDepartmentList()
          } else {
            const data = await response.json();
            console.log('CompanyDataerr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
        fetchData();
    }
    const [openForm, setOpenForm] = useState(false); // Define the state for opening the form
    const [editFormData, setEditFormData] = useState(null); // New state for editing data
    const { control, handleSubmit, reset, register, setValue } = useForm({
      defaultValues: editFormData || {
        departmentName: '',
        departmentShortName: '',
        departmentDescription: '',
        subDepartments: [{ subDeptName: '', subDeptShortName: '', subDeptDescription: '' }],
      },
    });  

    const { fields, append, remove } = useFieldArray({
      control,
      name: 'subDepartments',
    });
    console.log('fields',fields)
    const editDepartment = (department) => {
      setIsEdit(true)
      console.log('department',department)
      setEditFormData(department);
      setOpenForm(true);
    };
    const hideForm = () =>{
      setOpenForm(false);
      setEditFormData(null)
      getDepartmentList();

  }
    const addSubDepartment = (id) =>{
      setIsEdit(false)
      setAppendValue(false)
      console.log('deptid',id)
      setAddSubdeptId(id)
      setOpenSubDeptForm(true)
    }
    const onEditSubmit = async (formData) => {
      if ( !formData.departmentName) {
        toast.error('Please fill Department Name.');
        return; // Prevent further execution if fields are not filled
      }
      if ( !formData.departmentShortName) {
        toast.error('Please fill Department Short Name.');
        return; // Prevent further execution if fields are not filled
      }
      // Perform the update operation using the updateDepartment function
      console.log('formData',formData)
      setEditFormData(null)

      
      // Creating a new object without the "subDepartments" property
      const { subDepartments, isActive,
        createdBy,
        boOwnerId,
        createdAt,departmentId,updatedAt,updateBy, ...newObject } = formData;
      
      console.log(newObject);
      const filteredNewObject = Object.fromEntries(
        Object.entries(newObject).filter(([key, value]) => value !== '')
      );
      
      console.log('filteredNewObject',filteredNewObject);
      console.log('editFormData.departmentId',editFormData.departmentId)
      updateDepartment(editFormData.departmentId, filteredNewObject);
      setOpenForm(false);
    };
    useEffect(() => {
      reset(editFormData || {
        departmentName: '',
        departmentShortName: '',
        departmentDescription: '',
        subDepartments: [{ subDeptName: '', subDeptShortName: '', subDeptDescription: '' }],
      });
    }, [editFormData ]);
    const onSubmit = async (formData) => {
      console.log('formData',formData)
      if ( !formData.departmentName) {
        toast.error('Please fill Department Name.');
        return; // Prevent further execution if fields are not filled
      }
      if ( !formData.departmentShortName) {
        toast.error('Please fill Department Short Name.');
        return; // Prevent further execution if fields are not filled
      }
      if(formData.subDepartments && formData.subDepartments.length > 0){
      let isError = false;

        await formData.subDepartments.forEach((subDept, index) => {
          if (!subDept.subDeptName || subDept.subDeptName.trim() === '') {
            toast.error(`Please fill in Sub-Department Name #${index + 1}.`);
            isError = true;
            return;
          }
          
          if (!subDept.subDeptShortName || subDept.subDeptShortName.trim() === '') {
          toast.error(`Please fill in Sub-Department Short Name #${index + 1}.`);
          isError = true;
          return;
        }
      });
      if (isError) {
        return;
      }
    }
      const formattedData = {
        departments:  [{
        departmentName: formData?.departmentName,
        departmentShortName: formData?.departmentShortName,
        ...(formData?.departmentDescription && { departmentDescription : formData?.departmentDescription }),
        // departmentDescription: formData.departmentDescription,
        ...(formData?.subDepartments && formData?.subDepartments?.length > 0 && {
          subDepartments: formData?.subDepartments?.map((subDept) => ({
            subDeptName: subDept.subDeptName,
            ...(subDept.subDeptDescription && { subDeptDescription : subDept.subDeptDescription }),
            // subDeptDescription: subDept.subDeptDescription,
            subDeptShortName: subDept.subDeptShortName,
            subDeptId: subDept.subDeptId, // You might want to generate or assign an ID
          })),
        }),
      }]
      };
    
      console.log('formattedData',formattedData);

      const token = localStorage.getItem('authToken');

      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${AddDepartment}`, {
          method: "POST",
          headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify(formattedData),
        });
        
        if (response.ok) {
          const data = await response.json();
          setCallFetch(true)
          console.log('CompanyData',data)
          // setLocations(data.data)
          // setLocationTitle(`Location ${data.data.length + 1}`);
        } else {
          const data = await response.json();
          console.log('CompanyDataerr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      await fetchData();
      const newData = [...data, formattedData];
      console.log('newdata',newData)
      setData(newData);
      reset(); // Reset the form after submission
      setOpenForm(false); // Close the form after submission
    };

    useEffect(() => {
      getDepartmentList();
      setCallFetch(false)
    }, [openForm,openSubDeptForm, callFetch]);
    const getDepartmentList = async () =>{
      const token = localStorage.getItem('authToken');
    
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
          method: "POST",
          headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify({isDeleted:false}),
        });
        
        if (response.ok) {
          const data = await response.json();
          const activeDepartment = data.data.filter(item => item.isActive);

          console.log('department',data)
          setDepartmentList(activeDepartment)
          const newArray = activeDepartment.map((item) => ({
            value: item.departmentName,
            key: item.departmentId
          }));
          sessionStorage.setItem('department', JSON.stringify(newArray));
          dispatch(setDept(newArray));

          // setLocations(tableshowData);
        
        } else {
          const data = await response.json();
          console.log('departmenterr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      };
      await fetchData();
    }

    const updateDepartment = (id , newData) =>{
      const token = localStorage.getItem('authToken');

          const fetchData = async () => {
            const response = await fetch(`${BASE_URL}/${UpdateDepartment}/${id}`, {
              method: "PUT",
              headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${token}`,
                        
                      },
              body: JSON.stringify(newData),
            });
            
            if (response.ok) {
              const data = await response.json();
              setCallFetch(true)
              console.log('CompanyDataa',data)
              setEditFormData(null)
          
            } else {
              const data = await response.json();
              console.log('CompanyDataerr',data)
              toast.error(data.errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
              });
              
            }
          };
          fetchData();
    }
    const deleteDepartment = (id) =>{
      const token = localStorage.getItem('authToken');

          const fetchData = async () => {
            const response = await fetch(`${BASE_URL}/${DeleteDepartment}/${id}`, {
              method: "PUT",
              headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${token}`,
                        
                      },
              body: JSON.stringify(),
            });
            
            if (response.ok) {
              const data = await response.json();
              setCallFetch(true)
              console.log('CompanyDataa',data)
          
            } else {
              const data = await response.json();
              console.log('CompanyDataerr',data)
              toast.error(data.errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
              });
              
            }
          };
          fetchData();
    }

    const addMoreDepartment = () => {
      setIsEdit(false)
      setAppendValue(false)
      setOpenForm(true)
      reset();
      setEditFormData(null)

    }

    const navigate = useNavigate();
    const handlecompany = () => {
      navigate('/designation');
    }
    const addcompany = () => {
      navigate('/addcompanylocation');
    }
    // const columns = [
    //   {
    //     title: 'S. No.',
    //     dataIndex: 'sno',
    //   },
    //   {
    //     title: <>Department <br />Name</>,
    //     dataIndex: 'department',
    //   },
    //   {
    //     title: <>Name<br />(short)</>,
    //     dataIndex: 'name',
    //   },
    //   {
    //     title: 'Description',
    //     dataIndex: 'description',
    //   },
    //   {
    //     title: 'Actions',
    //     dataIndex: 'actions',
    //     render: (_, record) => (
    //       <div>
    //         {record.subdepartments?.map((subDept, index) => (
    //           <div key={index} className='flex' style={{ justifyContent: 'center', display: 'flex' }}>
    //             <BsPencil
    //               style={{
    //                 border: '1px solid #D7E7F8',
    //                 padding: '3px',
    //                 backgroundColor: '#D7E7F8',
    //                 borderRadius: '50%',
    //                 fontSize: '17px',
    //                 marginRight: '5px',
    //               }}
    //             />
    //             <DeleteOutlined
    //               style={{
    //                 border: '1px solid #D7E7F8',
    //                 padding: '3px',
    //                 backgroundColor: '#F5E7E9',
    //                 borderRadius: '50%',
    //                 fontSize: '10px',
    //                 color: '#DC3545',
    //               }}
    //             />
    //           </div>
    //         ))}
    //       </div>
    //     ),
    //   },

    // ];
  
    // // const data = [];
    // // for (let i = 0; i < 3; i++) {
    //   // const subDepartments = [
    //   //   formattedData
    //   // ];
    //   const subDepartments = [
    //   //  formattedData
    //     { name: 'Sale', shortName:'sale' ,description: 'Lorem Ipsum dolor sir' },
    //     { name: 'Import', shortName:'Import', description: 'Lorem Ipsum dolor' },
    //     { name: 'Export', shortName:'Export', description: 'Lorem Ipsum dolor' },
    //   ];
    //   console.log('subDepartments',subDepartments)
    //   data.push({
    //     key: 1,
    //     sno: '1',
    //     department: (
    //       <>
    //         {subdepartments?.map((subDept, index) => (
    //           <>
    //           <p key={index} className='department'>{subDept.name}</p> <br />
    //           <p>hello</p>
    //           </>
    //         ))}
    //       </>
    //     ),
    //     name: (
    //       <>
    //         {subdepartments?.map((subDept, index) => (
    //           <>
    //           <p key={index} className='name'>{subDept.shortName}</p><br />
    //           <p>hello</p>
    //           </>
    //         ))}
    //       </>
    //     ),
    //     description: (
    //       <>
    //         {subdepartments?.map((subDept, index) => (
    //           <>
    //           <p key={index} className='lorem-des'>{subDept.description}</p><br />
    //           <p>hello</p>
    //           </>
    //         ))}
    //       </>
    //     ),
    //     subDepartments: subDepartments,
    //   });
    // // }
    return (
      <>
            <ToastContainer position="top-right" autoClose={2000} />

        <div className="h-full">
          <Row className="2xl:h-full xl:h-auto">
              <SignUpSidebar isDepartment={ true } location={location.pathname} />
              <Col lg={14} className="bg-[#F5FBFE] h-full text-base overflow-auto">
            <div className=" flex flex-col pt-10">
              <div className='font-bold text-[28px] text-center mt-3 mb-4'>Department & Sub-Departments</div>
              <div className='dep-org-table mx-[50px]'>
                {/* <Table columns={columns} dataSource={data} pagination={false} /> */}
                <table className="table table-default">
                  <thead>
                    <tr>
                      <th scope="col">S No.</th>
                      <th scope="col" className='leading-none'>Department <br/>Name</th>
                      <th scope="col" className='leading-none'>Name <br/><small>(short)</small></th>
                      <th scope="col">Description</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr></tr>
                    {departmentList.map((item, index) => (
                    <tr className='ft12 font-weight-bold'>
                      <td scope="row" className='text-center text-lg'>{index + 1}</td>
                      <td className='text-center'>
                        <div className='inline-table text-start'>
                          <p className='mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 min-w-[148px] h-[30px] inline-flex items-center'>
                            {capitalizeFirstLetter(item.departmentName)}
                          </p>
                          <ul className='flex flex-col items-end'>
                            {item?.subDepartments?.filter(data => data.isActive).map((data,index)=>(
                              <li className='mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0'>
                                <span className='rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 w-[125px] truncate items-center ml-2'>
                                  {capitalizeFirstLetter(data.subDeptName)}
                                </span>
                              </li>
                            ))}
                            <li className='before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0 flex items-center mt-1'>
                              <img src={EditIcon} onClick={() => addSubDepartment(item.departmentId)} className='cursor-pointer w-3 h-3 ml-[13px]'/>
                              <span className='w-[100px] ml-[7px] inline-block'></span>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td className='text-center'>
                        <div className='inline-table text-start'>
                          <p className='mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 min-w-[148px] h-[30px] inline-flex items-center'>
                            {capitalizeFirstLetter(item.departmentShortName)}
                          </p>
                          <ul className='flex flex-col items-end'>
                            {item.subDepartments?.filter(data => data.isActive).map((data,index)=>(
                              <li className='mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0'>
                                <span className='rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 w-[125px] truncate items-center ml-2'>
                                  {capitalizeFirstLetter(data.subDeptShortName)}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </td>
                      <td className='text-center'>
                        <div className='inline-table text-start'>
                          <p className='mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 w-[185px] h-[30px] inline-flex items-center'>
                            <span className='truncate'>{capitalizeFirstLetter(item.departmentDescription)}</span>
                          </p>
                          <ul className='flex flex-col items-end'>
                            {item.subDepartments?.filter(data => data.isActive).map((data,index)=>(
                              <li className='mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0'>
                                <span className='rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 w-[150px] truncate items-center ml-2'>
                                  {capitalizeFirstLetter(data.subDeptDescription)}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </td>

                      <td className='text-center'>
                        <div className='inline-flex mb-1 mx-auto'>
                          <span className='shi-pen'><BsPencil  onClick={() => editDepartment(item)}/></span>
                          <span className='shi-not ml-2'><StopOutlined className='h-3' onClick={() => deleteDept(item.departmentId)}/></span>
                        </div>
                        <ul>
                          {item.subDepartments?.filter(data => data.isActive).map((data,index)=>(
                          <li>
                            <div className='flex items-center justify-center'>
                              <span className='shi-pen !text-xs bg-transparent h-5 w-5'><BsPencil onClick={() => editSubDepartment(item.departmentId,data)}/></span>
                              <span className='w-5 shi-not h-5 items-center flex !ml-[18px]'><StopOutlined onClick={() => deleteSubDept({item,data})} className='h-3 cursor-pointer'/></span>
                            </div>
                          </li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                    ))}
                  
                  </tbody>
                </table>
              </div>
              <div className='add-center'>
                <Button className='h-10 border !border-[#00305F] text-[#00305F] rounded-full hover:bg-[#00305F] hover:!text-white px-4 !outline-none' onClick={() => addMoreDepartment()}>
                  <span className='font-sbold text-sm'>+Add More Department</span>
                </Button>
                {/* <p className='depart-add-plush'>+Add More Company</p> */}
              </div>
              {/* <Modal
        
          title={editFormData ? 'Edit Department' : 'Add Department'}
          open={openForm}
          okText={"Add Department"}
          okButtonProps={{ style: { background: 'grey' } }}
          onCancel={() => {
            console.log('cancel call')
            setOpenForm(false);
            setEditFormData(null);
            reset();
            setAppendValue(false);
          }}
          footer={null}
          
        >
          <form style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="pro-add-work-back ml-2 mr-2">
      
      <div className="block">
            <div className='form-field shiftLabel'>
              <label className='mb-0 mt-1'>Department Name<span className='text-red-500'>*</span>:</label>
              <Controller name='departmentName'
              control={control} defaultValue={editFormData !== null ? editFormData.departmentName : ''}
              render={({ field }) => 
              <input         className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
              {...field} />} />
            </div>

            <div className='form-field shiftLabel'>
              <label className='mb-0 mt-1'>Department Short Name<span className='text-red-500'>*</span> (Maximum 5 letters are allowed):</label>
              <Controller
                name='departmentShortName'
                control={control}
                defaultValue={editFormData ? editFormData.departmentShortName : ''}
                render={({ field }) =>
                <input maxLength={5} className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                {...field} />}
              />
            </div>

            <div className='form-field shiftLabel'>
              <label className='mb-0 mt-1'>Department Description:</label>
              <Controller
                name='departmentDescription'
                control={control}
                defaultValue={editFormData ? editFormData.departmentDescription : ''}
                render={({ field }) => <input          className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                {...field} />}
              />
            </div>
            </div>
            </div>
            {!isEdit ?
            <div className='sub-dept-section'>
              {apendValue == true && ( <label className='mt-3 ml-2'><strong>Sub-Departments</strong></label>)}
              {fields.map((subDept, index) => (
                <>
                {apendValue == false && (<> ${remove(0)} </>)}
                <div key={subDept.id} className='sub-dept-field'>
                  <div className="pro-add-work-back ml-2 mr-2">
      
      <div className="block">
                  <div className='form-field shiftLabel'>
                    <label className='mb-0 mt-1'>Sub-Dept Name<span className='text-red-500'>*</span>:</label>
                    <Controller
                      name={`subDepartments[${index}].subDeptName`}
                      control={control}
                      className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"

                      defaultValue=''
                      render={({ field }) => <input         className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                      {...field} />}
                    />
                  </div>

                  <div className='form-field shiftLabel'>
                    <label className='mb-0 mt-1'>Sub-Dept Short Name<span className='text-red-500'>*</span> (Maximum 5 letters are allowed):</label>
                    <Controller
                      name={`subDepartments[${index}].subDeptShortName`}
                      control={control}
                      defaultValue=''
                      render={({ field }) => <input maxLength={5} className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                      {...field} />}
                    />
                  </div>

                  <div className='form-field shiftLabel'>
                    <label className='mb-0 mt-1'>Sub-Dept Description:</label>
                    <Controller
                      name={`subDepartments[${index}].subDeptDescription`}
                      control={control}
                      defaultValue=''
                      render={({ field }) => <input         className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                      {...field} />}
                    />
                  </div>
                  <Button type='button' className=' mt-1 depart-add-plush' onClick={() => remove(index)}>
                    Remove Sub-Department
                  </Button>
                  </div>
                  </div>
                
                </div>
                  </>
              ))}
            </div>
              : ""}
                {!isEdit ?
            <Button
              type='button'
              style={{alignSelf: 'center'}}
              className="!border-[#00305F] mt-2  text-[#00305F] hover:bg-[#00305F] hover:!text-[#fff] rounded-full py-2 px-5 h-auto !text-sm"
              onClick={() =>{setAppendValue(true); append({ subDeptName: '', subDeptShortName: '', subDeptDescription: '' })}}
            >
              Add Sub-Department
            </Button>
            : ""}
            <div className="text-center mt-4">
                  <Button
                    className="!border-[#00305F]  text-[#00305F] hover:bg-[#00305F] hover:!text-[#fff] rounded-full py-2 px-5 h-auto !text-sm"
                  onClick={editFormData ? handleSubmit(onEditSubmit) : handleSubmit(onSubmit)}
                  >
                    <span className="font-sbold">+Add Department</span>
                  </Button>
                </div>
          </form>
        </Modal> */}
        <Modal
    title={editSubDeptFormData ? 'Edit Sub-Department' : 'Add Sub-Department'}
    open={openSubDeptForm}
    okText={"Add Department"}
    okButtonProps={{ style: { background: 'grey' } }}
    // onOk={editSubDeptFormData ? handleSubmitSubDept(onEditSubDeptSubmit) : handleSubmitSubDept(onSubDeptSubmit)}
    onCancel={() => {
      setOpenSubDeptForm(false);
      setEditSubDeptFormData(null);
      resetSubDeptForm();
    }}
    footer={null}
  >
    <form style={{ display: 'flex', flexDirection: 'column' }}>
      <div className='sub-dept-section '>
        <label className='ml-2'><strong>Sub-Departments</strong></label>
        {subDeptFields.map((subDept, index) => (
          
          <div key={index} className='sub-dept-field shiftLabel'>
            <div className="pro-add-work-back ml-2 mr-2">
      
      <div className="block">
            <div className='form-field shiftLabel'>
              <label className='mb-0 mt-1'>Sub-Dept Name<span className='text-red-500'>*</span>:</label>
              <input
                className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                type="text"
                {...registerSubDept(editSubDeptFormData ? `subDeptName` : `subDepartments[${index}].subDeptName`)}
                defaultValue={editSubDeptFormData ? editSubDeptFormData.subDeptName : ''}
              />
            </div>

            <div className='form-field shiftLabel'>
              <label className='mb-0 mt-1'>Sub-Dept Short Name<span className='text-red-500'>*</span> (Maximum 5 letters are allowed):</label>
              <input
                className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                type="text"
                maxLength={5}
                {...registerSubDept(editSubDeptFormData ? `subDeptShortName` : `subDepartments[${index}].subDeptShortName`)}
                defaultValue={editSubDeptFormData ? editSubDeptFormData.subDeptShortName : ''}
              />
            </div>

            <div className='form-field shiftLabel'>
              <label className='mb-0 mt-1'>Sub-Dept Description:</label>
              <input
                className="h-10 bg-[#BACAD8] rounded-full px-5 w-full placeholder:text-[13px] outline-none mt-2"
                type="text"
                {...registerSubDept(editSubDeptFormData ? `subDeptDescription` : `subDepartments[${index}].subDeptDescription`)}
                defaultValue={editSubDeptFormData ? editSubDeptFormData.subDeptDescription : ''}
              />
            </div>
            {!isEdit ? 
            <Button type='button' className='depart-add-plush mt-1' onClick={() => removeSubDept(index)}>
              Remove Sub-Department
            </Button>
          : ""}
          </div>
          </div>
          </div>
        ))}
      </div>
      {!isEdit ? 
      <Button
        type='button'
        style={{alignSelf: 'center'}}
        className='depart-add-plush addSubBtn'
        onClick={() => appendSubDept({ subDeptName: '', subDeptShortName: '', subDeptDescription: '' })}
      >
        Add Sub-Department
      </Button>
      : ""}

      {/* <button type='submit'>Submit</button> */}
    </form>
    <div className="text-center mt-4">
                  <Button
                    className="!border-[#00305F]  text-[#00305F] hover:bg-[#00305F] hover:!text-[#fff] rounded-full py-2 px-5 h-auto !text-sm"
                  onClick={editSubDeptFormData ? handleSubmitSubDept(onEditSubDeptSubmit) : handleSubmitSubDept(onSubDeptSubmit)}
                  >
                    <span className="font-sbold">+Add Sub Department</span>
                  </Button>
                </div>
  </Modal>
              <div className='flex gap-2 justify-end px-5 mt-5'>
                <img src={Left} onClick={addcompany} className='w-12 cursor-pointer'/>
                <img src={Right} onClick={handlecompany} className='w-12 cursor-pointer'/>
              </div>
            </div>
          </Col>
        </Row>
        </div>
        <DepartmentForm
          visible={openForm}
          onCancel={hideForm}
          editItem={editFormData}
          // initialValues={editItem}
          // isEdit={editItem !== null}
        
        />

        <ModalConfirm
          visible={modalDeleteDeptVisible}
          onOk={() => handleOk(deleteDeptData)}
          onCancel={handleCancel}
          title="Delete"
          content="Are you sure you want to delete?"
        />
          <ModalConfirm
          visible={modalDeleteSubDeptVisible}
          onOk={() => handleSubOk(deleteSubDeptData)}
          onCancel={handleSubCancel}
          title="Delete"
          content="Are you sure you want to delete?"
        />
      </>
    )
  }

  export default DepartmentAndsubDepartment